import {
  ADD_SALARY_ADVANCE_REQUEST_REQUEST,
  ADD_SALARY_ADVANCE_REQUEST_SUCCESS,
  ADD_SALARY_ADVANCE_REQUEST_FAILURE,
  FETCH_SALARY_ADVANCE_REQUESTS_REQUEST,
  FETCH_SALARY_ADVANCE_REQUESTS_SUCCESS,
  FETCH_SALARY_ADVANCE_REQUESTS_FAILURE,
  FETCH_SALARY_ADVANCE_DETAILS_REQUEST,
  FETCH_SALARY_ADVANCE_DETAILS_SUCCESS,
  FETCH_SALARY_ADVANCE_DETAILS_FAILURE,
  UPDATE_SALARY_ADVANCE_REQUEST_REQUEST,
  UPDATE_SALARY_ADVANCE_REQUEST_SUCCESS,
  UPDATE_SALARY_ADVANCE_REQUEST_FAILURE,
  DELETE_SALARY_ADVANCE_REQUEST_REQUEST,
  DELETE_SALARY_ADVANCE_REQUEST_SUCCESS,
  DELETE_SALARY_ADVANCE_REQUEST_FAILURE,
  ADD_APPROVE_REQUEST_REQUEST,
  ADD_APPROVE_REQUEST_SUCCESS,
  ADD_APPROVE_REQUEST_FAILURE,
  ADD_ATTEST_REQUEST_REQUEST,
  ADD_ATTEST_REQUEST_SUCCESS,
  ADD_ATTEST_REQUEST_FAILURE,
  ADD_VERIFY_REQUEST_REQUEST,
  ADD_VERIFY_REQUEST_SUCCESS,
  ADD_VERIFY_REQUEST_FAILURE,
  ADD_REJECT_REQUEST_REQUEST,
  ADD_REJECT_REQUEST_SUCCESS,
  ADD_REJECT_REQUEST_FAILURE,
  ADD_PAY_REQUEST_REQUEST,
  ADD_PAY_REQUEST_SUCCESS,
  ADD_PAY_REQUEST_FAILURE,
  ADD_QUERY_REQUEST_REQUEST,
  ADD_QUERY_REQUEST_SUCCESS,
  ADD_QUERY_REQUEST_FAILURE,
  ADD_COMMENT_REQUEST_REQUEST,
  ADD_COMMENT_REQUEST_SUCCESS,
  ADD_COMMENT_REQUEST_FAILURE,
  SUBMIT_SALARY_REQUEST_REQUEST,
  SUBMIT_SALARY_REQUEST_SUCCESS,
  SUBMIT_SALARY_REQUEST_FAILURE,
  FETCH_SALARY_ADVANCE_VOUCHERS_REQUEST,
  FETCH_SALARY_ADVANCE_VOUCHERS_SUCCESS,
  FETCH_SALARY_ADVANCE_VOUCHERS_FAILURE,
  CLEAR_SALARY_ADVANCE_REQUESTS_ERROR,
} from "../actions/salaryAdvanceRequestActionTypes";

const initialState = {
  salaryAdvanceRequests: [],
  salaryAdvanceDetails: null,
  salaryAdvanceVouchers: null,
  isLoading: false,
  errors: {
    addSalaryAdvanceRequest: null,
    approve: null,
    attest: null,
    verify: null,
    reject: null,
    pay: null,
    query: null,
    fetchSalaryAdvanceRequests: null,
    fetchSalaryAdvanceDetails: null,
    fetchSalaryAdvanceVouchers: null,
    updateSalaryAdvanceRequest: null,
    deleteSalaryAdvanceRequest: null,
    submit: null,
  },
};

const normalizeRequests = (requests) => {
  if (Array.isArray(requests)) return requests;
  if (requests && typeof requests === "object" && requests.id)
    return [requests];
  return [];
};

const salaryAdvanceRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_SALARY_ADVANCE_REQUEST_REQUEST:
    case FETCH_SALARY_ADVANCE_REQUESTS_REQUEST:
    case UPDATE_SALARY_ADVANCE_REQUEST_REQUEST:
    case DELETE_SALARY_ADVANCE_REQUEST_REQUEST:
    case ADD_APPROVE_REQUEST_REQUEST:
    case ADD_ATTEST_REQUEST_REQUEST:
    case ADD_VERIFY_REQUEST_REQUEST:
    case ADD_REJECT_REQUEST_REQUEST:
    case ADD_PAY_REQUEST_REQUEST:
    case ADD_QUERY_REQUEST_REQUEST:
    case ADD_COMMENT_REQUEST_REQUEST:
    case SUBMIT_SALARY_REQUEST_REQUEST:
    case FETCH_SALARY_ADVANCE_VOUCHERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        errors: {
          ...state.errors,
          [action.type.replace("_REQUEST", "").toLowerCase()]: null,
        },
      };

    case ADD_SALARY_ADVANCE_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        salaryAdvanceRequests: [
          ...state.salaryAdvanceRequests,
          { ...action.payload, id: action.payload.id || Date.now() },
        ],
        errors: { ...state.errors, addSalaryAdvanceRequest: null },
      };

    case FETCH_SALARY_ADVANCE_REQUESTS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        salaryAdvanceRequests: normalizeRequests(action.payload),
        salaryAdvanceDetails: action.payload,
        errors: { ...state.errors, fetchSalaryAdvanceRequests: null },
      };

    case FETCH_SALARY_ADVANCE_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        salaryAdvanceDetails: action.payload,
        errors: { ...state.errors, fetchSalaryAdvanceDetails: null },
      };

    case UPDATE_SALARY_ADVANCE_REQUEST_SUCCESS:
    case ADD_APPROVE_REQUEST_SUCCESS:
    case ADD_ATTEST_REQUEST_SUCCESS:
    case ADD_VERIFY_REQUEST_SUCCESS:
    case ADD_REJECT_REQUEST_SUCCESS:
    case ADD_PAY_REQUEST_SUCCESS:
    case ADD_QUERY_REQUEST_SUCCESS:
    case ADD_COMMENT_REQUEST_SUCCESS:
    case SUBMIT_SALARY_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        salaryAdvanceRequests: normalizeRequests(
          state.salaryAdvanceRequests,
        ).map((request) =>
          request.id === action.payload.id ? action.payload : request,
        ),
        salaryAdvanceDetails:
          state.salaryAdvanceDetails?.id === action.payload.id
            ? action.payload
            : state.salaryAdvanceDetails,
        errors: {
          ...state.errors,
          [action.type.replace("_SUCCESS", "").toLowerCase()]: null,
        },
      };

    case DELETE_SALARY_ADVANCE_REQUEST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        salaryAdvanceRequests: state.salaryAdvanceRequests.filter(
          (request) => request.id !== action.payload,
        ),
        errors: { ...state.errors, deleteSalaryAdvanceRequest: null },
      };

    case FETCH_SALARY_ADVANCE_VOUCHERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        salaryAdvanceVouchers: action.payload,
        errors: { ...state.errors, fetchSalaryAdvanceVouchers: null },
      };

    case ADD_SALARY_ADVANCE_REQUEST_FAILURE:
    case FETCH_SALARY_ADVANCE_REQUESTS_FAILURE:
    case UPDATE_SALARY_ADVANCE_REQUEST_FAILURE:
    case DELETE_SALARY_ADVANCE_REQUEST_FAILURE:
    case ADD_APPROVE_REQUEST_FAILURE:
    case ADD_ATTEST_REQUEST_FAILURE:
    case ADD_VERIFY_REQUEST_FAILURE:
    case ADD_REJECT_REQUEST_FAILURE:
    case ADD_PAY_REQUEST_FAILURE:
    case ADD_QUERY_REQUEST_FAILURE:
    case ADD_COMMENT_REQUEST_FAILURE:
    case SUBMIT_SALARY_REQUEST_FAILURE:
      return {
        ...state,
        isLoading: false,
        errors: {
          ...state.errors,
          [action.type.replace("_FAILURE", "").toLowerCase()]:
            action.payload || "An error occurred.",
        },
      };

    case FETCH_SALARY_ADVANCE_VOUCHERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        salaryAdvanceVouchers: null,
        errors: {
          ...state.errors,
          fetchSalaryAdvanceVouchers:
            action.payload || "Failed to fetch salary advance vouchers.",
        },
      };

    case CLEAR_SALARY_ADVANCE_REQUESTS_ERROR:
      return {
        ...state,
        errors: initialState.errors,
      };

    default:
      return state;
  }
};

export default salaryAdvanceRequestReducer;
